import { Checklist } from '../types/ChecklistTypes';
import { ChecklistItemStatus } from '../types/ChecklistItemStatus.enum';
import { getVisibleItemsForSection } from './checklist-visible-entries';

export interface ChecklistProgress {
  completedItemCount: number;
  totalItemCount: number;
}

export function deriveChecklistProgress(
  checklist: Checklist
): ChecklistProgress {
  let completedItemCount = 0;
  let totalItemCount = 0;

  for (const section of checklist.sections ?? []) {
    for (const item of getVisibleItemsForSection(section)) {
      totalItemCount++;
      if (item.status !== ChecklistItemStatus.Unchecked) {
        completedItemCount++;
      }
    }
  }

  return { completedItemCount, totalItemCount };
}

/** The recent list reads these row counts, not the tree, so a local edit must restamp them or the card shows stale counts. */
export function withDerivedProgress(checklist: Checklist): Checklist {
  if ((checklist.sections ?? []).length === 0) {
    return checklist;
  }
  return { ...checklist, ...deriveChecklistProgress(checklist) };
}
